"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ScreenReaderOnly = exports.HiddenText = exports.Body = exports.PageTitle = exports.HeroTitle = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system");

var _rebass = require("rebass");

var _sharedStyle = require("../../styles/sharedStyle");

var _textStyles = require("../../styles/textStyles");
/* eslint-disable react/prop-types */

/* eslint-disable react/destructuring-assignment */

/* eslint-disable react/jsx-props-no-spreading */


var BaseText = (0, _styled.default)(_rebass.Text)(_styledSystem.display, _sharedStyle.textDecoration);
var BaseHeading = (0, _styled.default)(_rebass.Text)(function (_ref) {
  var shadow = _ref.shadow;
  return shadow && _sharedStyle.textShadow;
});

var HeroTitle = function HeroTitle(_ref2) {
  var size = _ref2.size,
      children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, ["size", "children"]);

  return /*#__PURE__*/_react.default.createElement(BaseHeading, Object.assign({
    as: "h1"
  }, _textStyles.heroTitleSize[size], rest), children);
};

exports.HeroTitle = HeroTitle;
HeroTitle.propTypes = {
  /** HeroTitle font size */
  size: _propTypes.default.oneOf(['xlarge', 'large', 'medium', 'small', 'xsmall'])
};
HeroTitle.defaultProps = {
  size: 'medium'
};

var PageTitle = function PageTitle(_ref3) {
  var size = _ref3.size,
      children = _ref3.children,
      rest = _objectWithoutProperties(_ref3, ["size", "children"]);

  return /*#__PURE__*/_react.default.createElement(BaseHeading, Object.assign({
    as: "h3"
  }, _textStyles.pageTitleSize[size], rest), children);
};

exports.PageTitle = PageTitle;
PageTitle.propTypes = {
  /** PageTitle font size */
  size: _propTypes.default.oneOf(['large', 'medium', 'small', 'xsmall', 'xxsmall'])
};
PageTitle.defaultProps = {
  size: 'medium'
};

var Body = function Body(_ref4) {
  var size = _ref4.size,
      children = _ref4.children,
      rest = _objectWithoutProperties(_ref4, ["size", "children"]);

  return /*#__PURE__*/_react.default.createElement(BaseText, Object.assign({
    as: "p"
  }, _textStyles.bodySize[size], rest), children);
};

exports.Body = Body;
Body.propTypes = {
  /** Body font size */
  size: _propTypes.default.oneOf(['xxlarge', 'xlarge', 'large', 'medium', 'small', 'xsmall'])
};
Body.defaultProps = {
  size: 'medium'
};

var HiddenText = function HiddenText(_ref5) {
  var children = _ref5.children,
      rest = _objectWithoutProperties(_ref5, ["children"]);

  return /*#__PURE__*/_react.default.createElement(BaseText, Object.assign({
    as: "span",
    display: "none"
  }, rest), children);
};

exports.HiddenText = HiddenText;

var ScreenReaderOnlyText = function ScreenReaderOnlyText(_ref6) {
  var children = _ref6.children,
      _ref6$as = _ref6.as,
      as = _ref6$as === void 0 ? 'span' : _ref6$as,
      rest = _objectWithoutProperties(_ref6, ["children", "as"]);

  return /*#__PURE__*/_react.default.createElement(BaseText, Object.assign({
    as: as
  }, rest), children);
};

var ScreenReaderOnly = (0, _styled.default)(ScreenReaderOnlyText)(function () {
  return {
    position: 'absolute',
    border: '0',
    padding: '0',
    margin: '0',
    width: '1px',
    height: '1px',
    clip: 'rect(0 0 0 0)',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontSize: '0',
    display: 'inline-block'
  };
});
exports.ScreenReaderOnly = ScreenReaderOnly;